export const MEMBER_STAKINGS_LISTING = "MEMBER_STAKINGS_LISTING";
export const MEMBER_STAKINGS_DROPDOWN = "MEMBER_STAKINGS_DROPDOWN";
export const MEMBER_STAKINGS_PAYOUT_DETAIL = "MEMBER_STAKINGS_PAYOUT_DETAIL";
export const STORE = "MEMBER_STAKINGS_STORE";
export const HISTORY = "MEMBER_STAKINGS_HISTORY";